import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorService } from '../../services/error.service';
import { ValidationFaultDto } from '../../shared.models';

@Component({
    selector: 'liebherr-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
    errorStatus?: number;
    errorMessage?: string;
    trackingNumber?: string;

    constructor(private errorService: ErrorService, private router: Router) {
        const error = this.errorService.getError();
        if (error) {
            this.parseError(error);
        } else {
            this.router.navigate(['/']);
        }
    }

    parseError(errorResponse: HttpErrorResponse) {
        this.errorStatus = errorResponse.status;
        console.warn('parseError', errorResponse);
        let exceptions: ValidationFaultDto[] = [];
        try {
            exceptions = errorResponse.error;
        } catch (e) {}
        if (exceptions && (exceptions as any).trackingNr) {
            this.trackingNumber = (exceptions as any).trackingNr;
        }
        if (errorResponse.status === 403) {
            // authz
            this.errorMessage = 'ERROR.ACCESS_FOR_RESOURCE_DENIED';
        } else if (
            errorResponse.status === 0 ||
            errorResponse.status === 404 ||
            errorResponse.status === 502 ||
            errorResponse.status === 503
        ) {
            if (errorResponse.status === 0) {
                this.errorStatus = 404; // dont display '0'
            }
            this.errorMessage = 'ERROR.NO_CONNECTION_TO_SERVER';
        } else {
            // unknown server exception; don't display to user
            this.errorMessage = 'ERROR.GENERAL_ERROR';
        }
        console.warn('parseErrorInfo:', this.errorMessage);
        console.warn('parseErrorStatus:', this.errorStatus);
    }
}
